import React from 'react';
import { 
  DropdownMenu, 
  DropdownMenuTrigger, 
  DropdownMenuContent, 
  DropdownMenuItem
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Share2, Link as LinkIcon, Mail, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';

const ShareMenu = ({ applyUrl, title }) => {
  if (!applyUrl) return null;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(applyUrl)
      .then(() => toast.success('Job link copied'))
      .catch(() => toast.error('Failed to copy link'));
  };

  const handleEmail = () => {
    const subject = encodeURIComponent(`Job Opportunity: ${title}`);
    const body = encodeURIComponent(`Check out this luxury retail role I found:\n\n${title}\n\nApply here: ${applyUrl}`);
    window.location.href = `mailto:contact@luxejobslondon.co.uk?subject=${subject}&body=${body}`;
  };

  const handleWhatsApp = () => {
    const text = encodeURIComponent(`Check out this luxury retail role: ${title} ${applyUrl}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground hover:bg-muted -mr-2 h-8 px-2 transition-colors"
        >
          <Share2 size={16} />
          <span>Share</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={handleCopyLink} className="cursor-pointer">
          <LinkIcon className="mr-2 h-4 w-4" />
          <span>Copy link</span>
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={handleEmail} className="cursor-pointer">
          <Mail className="mr-2 h-4 w-4" />
          <span>Email</span>
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={handleWhatsApp} className="cursor-pointer">
          <MessageCircle className="mr-2 h-4 w-4" />
          <span>WhatsApp</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ShareMenu;